// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Video_fullWidth__ZQTqg","preview":"Video_preview__T0XAp","thumbPreview":"Video_thumbPreview__Yplpr"};